import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyDMEbDmkeYdKwhBjLnbIng1zuPTxRhy9-I",
  authDomain: "tinder-clone-50401.firebaseapp.com",
  projectId: "tinder-clone-50401",
  storageBucket: "tinder-clone-50401.appspot.com",
  messagingSenderId: "816780990255",
  appId: "1:816780990255:web:af7fd91aaedd0646cdb3da",
  measurementId: "G-Y8TV53TPFC",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const database = firebaseApp.firestore();

export default database;
